export class SamplingPoint {

    CodeStation: string;
    Departement: string;
    CodeInsee: string;
    AccesGeographique: string;
    FinaliteSite: string;
    Reseau: string;
    Dreal: string;
    Typologie: string;
    HER: string;
    TresGrandBassinVersant: boolean;

    // Sampling Point ELIMS
    SamplingPointCode: string;
    SamplingPointName: string;
    AddressLine1: string;
    AddressLine2: string;
    AddressLine3: string;
    AddressLine4: string;
    AddressLine5: string;
    AddressLine6: string;
    City: string;
    ZipCode: string;

    static mapFromJSON(json): SamplingPoint {
        const s = new SamplingPoint();

        s.AddressLine1 = json.addressLine1;
        s.AddressLine2 = json.addressLine2;
        s.AddressLine3 = json.addressLine3;
        s.AddressLine4 = json.addressLine4;
        s.AddressLine5 = json.addressLine5;
        s.AddressLine6 = json.addressLine6;
        s.CodeStation = json.codeStation;
        s.AccesGeographique = json.accesGeographique;
        s.City = json.city;
        s.ZipCode = json.zipCode;
        s.Departement = json.departement;
        s.CodeInsee = json.codeInsee;
        s.Dreal = json.dreal;
        s.Typologie = json.typologie;
        s.HER = json.hER;
        s.TresGrandBassinVersant = json.tresGrandBassinVersant;
        s.SamplingPointCode = json.samplingPointCode;
        s.SamplingPointName = json.samplingPointName;

        return s;
    }
}
